export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-agnr-api.tracwater.online',
  portalId: '6a6aca5d7efe74d1d36eb17b',
  portalTypeId: '689596b618f8a8985a2aeb91',
  predictionURL:'https://testing-predection.tracwater.online/api/v1',
};
